export default __webpack_public_path__ + "static/apple-icon-114x114-df51189db22a4909dd4ae5fd0941d697.png";